module.exports = __webpack_public_path__ + "img/logo-byn.3ffa0035.png";